import { TRANSIT_NUMBERS } from './constants';

type FormatAsDollarOptions = Intl.NumberFormatOptions;
export function formatAsDollar(
  amount: number,
  options: FormatAsDollarOptions = {},
): string {
  return `$${amount.toLocaleString('en-US', {
    maximumFractionDigits: 0,
    ...options,
  })}`;
}

export const getPolicyStreamInstitutionNumber = (bankName: string) => {
  //console.log({ bankName });
  let transitNumber: string | null = null;
  switch (bankName) {
    case 'Bank of Montreal (BMO)':
      transitNumber = TRANSIT_NUMBERS.bmo;
      break;
    case 'Scotiabank':
      transitNumber = TRANSIT_NUMBERS.scotiaBank;
      break;
    case 'Canadian Imperial Bank of Commerce (CIBC)':
      transitNumber = TRANSIT_NUMBERS.cibc;
      break;
    case 'Royal Bank of Canada (RBC)':
      transitNumber = TRANSIT_NUMBERS.rbc;
      break;
    case 'Toronto-Dominion Bank (TD)':
      transitNumber = TRANSIT_NUMBERS.td;
      break;
  }
  //console.log({ bankName, transitNumber });
  return transitNumber;
};
